import { Component, OnInit, Output,Input, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserMediaAppSummaryModel } from 'src/app/shared/models';
import { BaseService, UserMediaAppService } from 'src/app/shared/services';
import { AppUtils } from 'src/helpers';
import { FilterModel } from 'src/app/shared/models';
import { Router } from "@angular/router";
import { SharedModule } from '../../../../shared/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule],
  selector: 'app-media-list-dn-design-link',
  templateUrl: './media-list-dn-design-link.component.html',
  styleUrls: ['./media-list-dn-design-link.component.css']
})
export class MediaListDnDesignLinkComponent implements OnInit {
  @Output() closeDrawer: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;
  @Input() selectedGroupId: number;
  @Input() selectedDNDesignId: number;
  @Input() displayListId: number;
  @Input() selectedDesign: any;
  isLoading: boolean;
  isModelLoaded: boolean;
  filterModel = new FilterModel();
  totalRecords: number;
  model: Array<UserMediaAppSummaryModel>;
  hasMore: boolean;
  loadingMore: any;
  hasMediaList: boolean;
  newMediaIds = new Array<number>();
  subscriptions = new Array<Subscription>();
  sortOrder: string;
  currentUrl: string;

  constructor(
      private router: Router,
      private service: UserMediaAppService,
      private baseService: BaseService,
      public appUtils: AppUtils
  ) {
      this.model = new Array<UserMediaAppSummaryModel>();
      this.filterModel.sortBy = 'Title';
      this.filterModel.sortDir = 'asc';
  }

  ngOnInit() {
      this.getMedia(true);
      this.currentUrl = encodeURIComponent(this.router.url);
  }

  ngAfterViewInit() {
      this.scrollContainer.nativeElement.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll(event: any) {
      const element = this.scrollContainer.nativeElement;
      const scrollTop = element.scrollTop;
      const scrollHeight = element.scrollHeight;
      const clientHeight = element.clientHeight;

      if (scrollTop + clientHeight >= scrollHeight * 0.8 && this.hasMore && !this.loadingMore) {
          this.getMoreRecords();
      }
  }

  getMedia(initialLoading = false, limit = 15) {
      this.isLoading = true;
      this.isModelLoaded = false;
      this.filterModel.offset = 0;
      this.filterModel.limit = limit;
      this.filterModel.dnDesignerId = this.selectedDNDesignId;
      this.totalRecords = 0;
      const requestSubscription =
          this.service.getList(this.selectedGroupId, this.filterModel).subscribe({
              next: (response: any) => {
                  this.model = response;
                  this.totalRecords = response.length;
                  if (this.model.length > 0) {
                      this.model.forEach((x) => {
                          x.iconUrl = this.generateMediaIconUrl(x.mediaAppType);
                          x.showDefaultIcon = true;
                          x.lengthInSeconds = x.lengthInSeconds == 0 ? 10 : x.lengthInSeconds;
                      });
                  }

                  if (initialLoading) {
                      this.hasMediaList = this.model.length > 0;
                  }

                  const filteredElements = this.model.filter(x => this.newMediaIds.includes(x.id));
                  if (filteredElements && filteredElements.length > 0){
                      this.model = this.model.filter(x => !this.newMediaIds.includes(x.id));
                  }
                  this.isModelLoaded = true;
                  this.isLoading = false;
              },
              error: (error: any) => {
                  this.isLoading = false;
                  this.isModelLoaded = true;
                  this.baseService.processErrorResponse(error);
              },
          });
      this.subscriptions.push(requestSubscription);
  }
  groupId(groupId: any, filterModel: FilterModel) {
    throw new Error('Method not implemented.');
  }

  getMoreRecords() {
      if (this.isLoading) { return; }
      this.filterModel.limit = 5;
      this.filterModel.offset = this.totalRecords;
      this.loadingMore = true;
      this.isLoading = true;
      this.service.getList(this.selectedGroupId, this.filterModel).subscribe({
          next: (response: any) => {
              if (response && response.length > 0) {
                  response.forEach((x) => {
                      if(!this.model.some(y => y.id == x.id)){
                          x.iconUrl = this.generateMediaIconUrl(x.mediaAppType);
                      x.showDefaultIcon = true;
                      
                      this.model.push(x);
                      }
                      
                  });
                  this.totalRecords += response.length;

              } else {
                  this.hasMore = false;
              }
              this.isLoading = false;
              this.loadingMore = false;
              this.isModelLoaded = true;
          },
          error: (error: any) => {
              this.isLoading = false;
              this.isModelLoaded = true;
              this.loadingMore = false;
              this.baseService.processErrorResponse(error);
          },
      });
  }

  generateMediaIconUrl(mediaAppType: string): string {
      return `./assets/images/media-types/icons/v2/${mediaAppType}.svg`;
  }
  

  submit() { }

  onSearch() {
      if (this.filterModel.filterKey) {
          this.getMedia();
      }
  }

  clearSearch() {
      this.filterModel.filterKey = '';
      this.getMedia();
  }

  filterKeyChanged() {
      if (this.appUtils.isNullOrEmpty(this.filterModel.filterKey)) {
          this.getMedia();
      }
  }

  sortMedia() {
      if (this.sortOrder === 'ascending') {
          this.filterModel.sortBy = 'Title';
          this.filterModel.sortDir = 'asc';
      } else if (this.sortOrder === 'descending') {
          this.filterModel.sortBy = 'Title';
          this.filterModel.sortDir = 'desc';
      }

      this.getMedia(false, this.totalRecords);
  }
  editMedia(mediatype: string, mediaAppId: number, mediaId: number): void {
    switch (mediatype) {
        case "Image":
            this.router.navigate(['/user-media-app/bulk-upload'], {
                queryParams: {
                    mediaAppId: 4,
                    id: mediaId,
                    returnUrl: this.currentUrl
                }
            });
            break;
        case "PDF":
            this.router.navigate(['/user-media-app/bulk-upload'], {
                queryParams: {
                    mediaAppId: 6,
                    id: mediaId,
                    returnUrl: this.currentUrl
                }
            });
            break;
        case "Video":
            this.router.navigate(['/user-media-app/bulk-upload'], {
                queryParams: {
                    mediaAppId: mediaAppId,
                    id: mediaId,
                    returnUrl: this.currentUrl
                }
            });
            break;
        default:
            this.router.navigate(['/under-construction']);

    }
}

  cancel(): void {
    this.closeDrawer.emit({ closed: true });
  }

}
